import React, { useEffect, useState, useContext } from "react";
import { useHistory, useParams } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSelector, useDispatch } from "react-redux";
import { BASE_PATH } from ".././../constants/Global";
import "react-datepicker/dist/react-datepicker.css";
import Navigationtitle from "../include/Navigationtitle";
import DataService from ".././../services/tutorial.service";
import { catlistData, actlistData, setisfirsttime } from "../../actions/index";
import { decode } from "base-64";
import ColorPicker from "../team/ColorPicker";
import {
  getDatabase,
  ref,
  remove,
  onValue,
  set,
  update,
  push,
} from "firebase/database";
import { FirebaseContext } from "../../FirebaseContext";

function Editcategory(match) {
  const dispatch = useDispatch();
  const getpageData = useSelector((state) => state.setcatlistData);
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
  } = useForm();
  const [isDisabled, setDisabled] = useState(false);
  const loginuser = useSelector((state) => state.setUserlog);
  const history = useHistory({ forceRefresh: true });
  const { ctid } = useParams();
  const aid = localStorage.getItem("auction_id");
  const admin_id = localStorage.getItem("admin_id");
  const admin_name = localStorage.getItem("admin_name");
  const auction_name = localStorage.getItem("auction_name");
  const [cid, setCid] = useState(loginuser["cid"]);
  const [color, setColor] = useState("#fff");
  const [showColorPicker, setShowColorPicker] = useState(false);
  const [isMinPlayer, setIsMinPlayer] = useState(0);
  const updtoken = useSelector((state) => state.updtoken);
  const selectedUnSold = watch("unsoldcat");

  const { upddata } = useContext(FirebaseContext);
  const isfirsttime = useSelector((state) => state.isfirsttime);
  const getaucpageData = useSelector((state) => state.setactlistData);

  const inputArr = [
    // {
    //   type: "number",
    //   id: 1,
    //   value: "",
    //   af: ""
    // },
  ];

  const [addInputField, setAddInputField] = useState(inputArr);

  const addInput = () => {
    setAddInputField((s) => {
      return [
        ...s,
        {
          type: "number",
          id: s.length + 1,
          value: "",
          af: "",
        },
      ];
    });
  };
  ////  console.log(addInputField);

  const removeInputField = (i, index) => {
    // var incnumi='mincr_i_'+index
    // var incnuma='mincr_a_'+index
    // values.incnumi=""
    // values.incnuma=""
    setAddInputField((current) => current.filter((input) => input.id !== i));
  };

  // handleChnage for add input field
  // const handleChange = e => {
  //   e.preventDefault();

  //   const index = e.target.id;
  //   setArr(s => {
  //     const newArr = s.slice();
  //     newArr[index].value = e.target.value;

  //     return newArr;
  //   });
  // };

  const handleSHowColorPicker = () => {
    setShowColorPicker(!showColorPicker);
  };
  const handleFormChange = (index, event) => {
    // //  console.log('aaaaaa');
    // //  console.log(event.target.value)
    let data = [...addInputField];
    data[index]["value"] = event.target.value;
    setAddInputField(data);
  };
  const handleFormChangeAf = (index, event) => {
    let data = [...addInputField];
    data[index]["af"] = event.target.value;
    setAddInputField(data);
  };

  const onSubmit = (values) => {
    setDisabled(true);
    const id = toast.loading("Please wait...");
    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
    });
    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: JSON.stringify([
          { cid: cid, aid: aid, token: loginuser["token"] },
        ]),
      },
    };
    values["clr"] = color;
    values["ismin"] = isMinPlayer;
    values["mincr_n"] = addInputField.length;
    if (addInputField.length > 0) {
      // const fieldsToRemove=['type','id']
      var finalmincr = addInputField.map((obj) => {
        const newObj = {};
        for (const key in obj) {
          newObj["i"] = obj["value"];
          newObj["a"] = obj["af"];
        }
        return newObj;
      });
      values["mincr"] = finalmincr;
    } else {
      values["mincr"] = "";
    }

    //  console.log(values)
    DataService.editCategory(values, hdr)
      .then((res) => {
        let response = res.data;
        toast.dismiss(toastContainerId);
        //  console.log('cat response');
        //  console.log(response);
        //  console.log(values);
        if (response.success == true) {
          toast.success(response.msg, {
            theme: "dark",
            position: "bottom-center",
          });
          if (getpageData != 0) {
            ////  console.log(response.data.detail['mincr']);
            const updateitem = getpageData.responsedata.list.filter(
              (ele, ind) => {
                if (ele.cid == values.ctid) {
                  ele.cname = values.cname;
                  ele.plno = values.plno;
                  ele.minplno = values.minplno;
                  ele.mbid = values.mbid;
                  ele.incrs = values.incrs;
                  ele.resv = values.resv;
                  ele.hibid = values.hibid;
                  ele.cathibid = values.cathibid;
                  ele.clr = values.clr;
                  ele.ismin = values.ismin;
                  ele.unsoldcat = values.unsoldcat;
                  ele.mincr = response.data.detail["mincr"];
                }

                return ele;
              }
            );

            let responsedata = {
              responsedata: {
                path: getpageData.path,
                aid: aid,
                list: updateitem,
              },
            };
            dispatch(catlistData(responsedata));
          }
          const db = getDatabase();
          //  console.log(values)
          set(ref(db, "map/info/" + aid), {
            type: "3",
            upd: "2",
            id: decode(ctid),
            detail: {
              cathibid: values.cathibid,
              clr: values.clr,
              cname: values.cname,
              hibid: values.hibid,
              incrs: values.incrs,
              ismin: `${values.ismin}`,
              mbid: values.mbid,
              minplno: values.minplno,
              plno: values.plno,
              resv: values.resv,
              unsoldcat: values.unsoldcat,
              cid: response.data.detail.cid,
            },
            tkn: updtoken,
          });

          update(ref(db, "map/info/datastatus/" + aid), {
            work24: 3,
          }).catch((error) => {
            console.error("Error updating work24 status:", error);
          });

          push(ref(db, "map/info/workhistory"), {
            worktyp: "work24",
            id: admin_id,
            name: admin_name,
            timestamp: new Date().toISOString(),
            aname: auction_name,
            aid: aid,
          }).catch((error) => {
            console.error("Error adding work24 history:", error);
          });

          history.push(BASE_PATH + "auction-category");
        } else {
          toast.error(response.msg, { theme: "colored" });
        }

        setDisabled(false);
      })
      .catch(() => {
        //  console.log("Not valid");
        toast.dismiss(toastContainerId);
        toast.error("Not valid Server Error", { theme: "colored" });
        setDisabled(false);
      });
  };

  useEffect(() => {
    //  console.log("jjj");

    const updateitem = getpageData.responsedata?.list?.filter((ele, ind) => {
      if (ele.cid == decode(ctid)) {
        setValue("cname", ele.cname);
        setValue("plno", ele.plno);
        setValue("minplno", ele.minplno);
        setValue("mbid", ele.mbid);
        setValue("incrs", ele.incrs);
        setValue("resv", ele.resv);
        setValue("hibid", ele.hibid);
        setValue("cathibid", ele.cathibid);
        setValue("unsoldcat", ele.unsoldcat);
        setColor(
          ele.clr &&
            String(ele.clr).trim() !== "" &&
            String(ele.clr).trim() !== "null"
            ? ele.clr
            : "#fff"
        );
        setIsMinPlayer(ele.ismin == 1 ? true : false);
        if (ele.mincr != "" && ele.mincr != null && ele.mincr != "null") {
          var mincrArr = [];
          var mincrvalue = JSON.parse(ele.mincr);
          if (mincrvalue.length > 0) {
            for (var x = 0; x < mincrvalue.length; x++) {
              mincrArr.push({
                type: "number",
                id: x + 1,
                value: mincrvalue[x].i,
                af: mincrvalue[x].a,
              });
            }
            setAddInputField(mincrArr);
          }
        }
      }
    });
  }, []);
  useEffect(() => {
    const isFirstMount = localStorage.getItem("isFirstMount");
    //  console.log('isFirstMount')
    //  console.log(isFirstMount)
    if (!isFirstMount) {
      localStorage.setItem("isFirstMount", false);
    } else {
      localStorage.removeItem("isFirstMount");
      history.push("/auction-detail");
    }
  }, [history]);
  const firechange = (datasnap) => {
    if (datasnap.type == "1" && datasnap.upd == "3") {
      if (getaucpageData != 0) {
        const updateitem = getaucpageData.responsedata.list.filter(
          (ele) => ele.aid != datasnap.id
        );

        let responsedata = {
          responsedata: {
            path: getaucpageData.responsedata.path,
            cid: cid,
            list: updateitem,
          },
        };
        dispatch(actlistData(responsedata));
      }
      history.push(BASE_PATH + "my-auction");
    }
  };
  useEffect(() => {
    const savedUnsoldCat = getpageData?.responsedata?.unsoldcat;

    if (savedUnsoldCat !== undefined && savedUnsoldCat !== null) {
      setValue("unsoldcat", savedUnsoldCat.toString());
    }
  }, [getpageData, setValue]);
  useEffect(() => {
    if (upddata !== null) {
      if (upddata !== isfirsttime) {
        firechange(upddata);
        if (upddata.upd == "4") {
          dispatch(setisfirsttime(upddata));
        }
      }
    }
  }, [upddata]);
  const handleClickOutside = (event) => {
    if (
      showColorPicker &&
      !event.target.closest(".choose-color-div") &&
      !event.target.closest(".choose-picker-div")
    ) {
      setShowColorPicker(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [showColorPicker]);
  return (
    <>
      <div>
        <Navigationtitle data={match} />

        <div
          id="top-categories"
          className="top-cat-area default-padding bottom-less"
        >
          <div className="container-fluid">
            <div className="row">
              <div id="contact-us" className="reg-area">
                <div className="container-fluid">
                  <div className="row">
                    <div className="reg-items">
                      <div className="col-md-5  reg-form">
                        <form
                          onSubmit={handleSubmit(onSubmit)}
                          action=""
                          autoComplete="off"
                          encType="multipart/form-data"
                        >
                          <input
                            type="hidden"
                            value={decode(ctid)}
                            {...register("ctid")}
                          />
                          <div className="row myclass1">
                            <div className="col-md-12  addcat-margtop">
                              <div className="form-group text-box-margin">
                                <div className="col-md-2">
                                  {" "}
                                  <label
                                    typeof="cname"
                                    className="addcat-label"
                                  >
                                    {" "}
                                    Category Name *{" "}
                                  </label>
                                </div>
                                <div className="col-md-6">
                                  {" "}
                                  <input
                                    className="form-control addcat-input-control"
                                    placeholder="Category Name"
                                    type="text"
                                    {...register("cname", {
                                      required: true,
                                      required: "required field.",
                                    })}
                                  />
                                  {errors.cname && (
                                    <p className="text-error">
                                      {errors.cname.message}
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>

                            {/* <div className="col-xs-12 col-md-12 margin-top-14px">
                              <div className="form-group text-box-margin">
                                
                                <div className="col-xs-12 col-sm-9 col-md-10 col-md-offset-2 col-sm-offset-3">
                                    <label for="isminchk" className="labelcheck">
                                    is Minimum Limit?</label>
                                  </div>
                                
                              </div>
                            </div> */}
                            <div className="col-md-12 margin-top-14px margintop-0px">
                              <div className="form-group text-box-margin">
                                <div className="col-md-2">
                                  {" "}
                                  <label typeof="plno" className="addcat-label">
                                    {" "}
                                    Max Players{" "}
                                    <span className="spansmall">
                                      (Per Team)
                                    </span>
                                  </label>
                                </div>
                                <div className="col-md-4 addcat-margtop">
                                  {" "}
                                  <input
                                    className="form-control addcat-input-control"
                                    placeholder="Max Players"
                                    type="number"
                                    onWheel={(e) => e.target.blur()}
                                    {...register("plno")}
                                  />
                                </div>
                                <div className="col-md-2 addcat-labelcheck">
                                  {" "}
                                  <input
                                    className="form-control"
                                    type="checkbox"
                                    id="isminchk"
                                    checked={isMinPlayer}
                                    onChange={(e) => {
                                      if (e.target.checked === true) {
                                        setIsMinPlayer(1);
                                      } else {
                                        setIsMinPlayer(0);
                                        setValue("minplno", "0");
                                      }
                                    }}
                                  />
                                  <label
                                    typeof="mbid"
                                    className="minpl-div addcat-label"
                                  >
                                    {" "}
                                    Min Players{" "}
                                  </label>
                                </div>
                                <div className="col-md-4">
                                  {" "}
                                  <input
                                    className="form-control addcat-margtop addcat-input-control"
                                    placeholder="Min Players"
                                    type="number"
                                    onWheel={(e) => e.target.blur()}
                                    disabled={isMinPlayer == 1 ? false : true}
                                    {...register("minplno")}
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="col-md-12 margin-top-14px addcat-margtop">
                              <div className="form-group text-box-margin">
                                <div className="col-md-2">
                                  <label typeof="mbid" className="addcat-label">
                                    Base Bid
                                  </label>
                                </div>
                                <div className="col-md-4">
                                  {" "}
                                  <input
                                    className="form-control addcat-input-control"
                                    type="number"
                                    step="any"
                                    onWheel={(e) => e.target.blur()}
                                    placeholder="Minimum Bid"
                                    {...register("mbid")}
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="col-md-12 margin-top-14px margintop-0px">
                              <div className="form-group text-box-margin">
                                <div className="col-md-2">
                                  {" "}
                                  <label
                                    typeof="incrs"
                                    className="addcat-label"
                                  >
                                    {" "}
                                    Increment{" "}
                                  </label>
                                </div>
                                <div className="col-xs-10 col-md-4">
                                  {" "}
                                  <input
                                    className="form-control  addcat-input-control"
                                    placeholder="Increase"
                                    type="number"
                                    step="any"
                                    onWheel={(e) => e.target.blur()}
                                    {...register("incrs")}
                                  />
                                </div>
                                <div
                                  className="col-xs-2 col-md-6 add-Input-button addbtn-div addcat-margtop"
                                  onClick={addInput}
                                >
                                  +{" "}
                                  <span className="helptext">
                                    (click to multipal increment)
                                  </span>
                                </div>
                              </div>
                            </div>

                            {addInputField.map((item, i) => {
                              return (
                                <div id={i}>
                                  <div className="col-md-12 margin-top-14px margintop-0px">
                                    {" "}
                                    <div className="form-group text-box-margin">
                                      <div className="col-md-2">
                                        {" "}
                                        <label className="margin-top-14px margin-incr">
                                          {" "}
                                          Increment of{" "}
                                        </label>
                                      </div>
                                      <div className="col-md-4 incraf-control">
                                        {" "}
                                        <input
                                          className="form-control editincr-control"
                                          type="number"
                                          value={item.value}
                                          step="any"
                                          onWheel={(e) => e.target.blur()}
                                          onInput={(e) =>
                                            handleFormChange(i, e)
                                          }
                                          {...register("mincr_i_" + i, {
                                            required: true,
                                            required: "required field.",
                                          })}
                                        />
                                      </div>

                                      <div className="col-md-2">
                                        {" "}
                                        <label
                                          typeof="minplno"
                                          className="margin-after"
                                        >
                                          {" "}
                                          After{" "}
                                        </label>
                                      </div>
                                      <div className="col-md-3 incraf-control">
                                        {" "}
                                        <input
                                          className="form-control editincr-control"
                                          type="number"
                                          step="any"
                                          value={item.af}
                                          onWheel={(e) => e.target.blur()}
                                          onInput={(event) =>
                                            handleFormChangeAf(i, event)
                                          }
                                          {...register("mincr_a_" + i)}
                                        />
                                      </div>

                                      <div
                                        className="col-xs-2 col-md-1 margin-top-14px remincr add-Input-button margintop-0px addcat-crossbtn"
                                        onClick={() =>
                                          removeInputField(item.id, i)
                                        }
                                      >
                                        ×
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })}

                            <div className="col-md-12 margin-top-14px addcat-margtop">
                              <div className="form-group text-box-margin">
                                <div className="col-md-2">
                                  <label typeof="resv" className="addcat-label">
                                    {" "}
                                    Reserve Bid{" "}
                                  </label>
                                </div>
                                <div className="col-md-6">
                                  {" "}
                                  <input
                                    className="form-control addcat-input-control"
                                    placeholder="Reserve Bid"
                                    type="number"
                                    step="any"
                                    onWheel={(e) => e.target.blur()}
                                    {...register("resv", {
                                      required: true,
                                      required: "required field.",
                                    })}
                                  />
                                </div>
                              </div>
                            </div>

                            {/* <div className="col-md-12 margin-top-14px">
                              <div className="form-group text-box-margin">
                                <div className="col-md-2">
                                  <label typeof="resv"> Reserv Bid </label>
                                </div>
                                <div className="col-md-4">
                                  {" "}
                                  <input
                                    className="form-control"
                                    placeholder="Reserv Bid"
                                    type="number"
                                    step="any"
                                    onWheel={(e) => e.target.blur()}
                                    {...register("resv")}
                                  />
                                </div>
                              </div>
                            </div> */}

                            <div className="col-md-12 margin-top-14px addcat-margtop">
                              <div className="form-group text-box-margin">
                                <div className="col-md-2">
                                  {" "}
                                  <label
                                    typeof="hibid"
                                    className="addcat-label"
                                  >
                                    {" "}
                                    Highest Bid{" "}
                                  </label>
                                </div>
                                <div className="col-md-4">
                                  {" "}
                                  <input
                                    className="form-control addcat-input-control"
                                    placeholder="Highest Bid"
                                    type="number"
                                    step="any"
                                    onWheel={(e) => e.target.blur()}
                                    {...register("hibid")}
                                  />
                                </div>
                                <span className="padding-left-16px addcat-label">
                                  per Player
                                </span>
                              </div>
                            </div>

                            <div className="col-md-12 margin-top-14px addcat-margtop">
                              <div className="form-group text-box-margin">
                                <div className="col-md-2">
                                  <label
                                    typeof="cathibid"
                                    className="addcat-label"
                                  >
                                    {" "}
                                    Category Highest Bid{" "}
                                  </label>
                                </div>
                                <div className="col-md-4">
                                  {" "}
                                  <input
                                    className="form-control addcat-input-control"
                                    placeholder="Category Highest Bid"
                                    type="number"
                                    step="any"
                                    onWheel={(e) => e.target.blur()}
                                    {...register("cathibid")}
                                  />
                                </div>
                                <span className="padding-left-16px addcat-label">
                                  for All Player
                                </span>
                              </div>
                            </div>

                            <div className="col-md-12 margin-top-14px addcat-margtop">
                              <div className="col-md-2">
                                <label className="addcat-label">
                                  {" "}
                                  Category Color{" "}
                                </label>
                              </div>
                              <div className="col-md-4">
                                <div
                                  className="choose-color-div"
                                  onClick={handleSHowColorPicker}
                                >
                                  <div className="choose-color-text">
                                    Category Color
                                  </div>{" "}
                                  <div
                                    className="circle"
                                    style={{ backgroundColor: color }}
                                  ></div>{" "}
                                </div>
                                {showColorPicker ? (
                                  <div className="choose-picker-div">
                                    <ColorPicker
                                      setColor={setColor}
                                      color={color}
                                    />
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                            <div className="col-md-12 margin-top-14px addcat-margtop">
                              {/* <div className="col-md-6">
                                <div className="form-group text-box-margin"> */}
                              <div className="col-md-2">
                                <label htmlFor="spcf1" className="addcat-label">
                                  {" "}
                                  Unsold category{" "}
                                </label>
                              </div>

                              <div className="col-md-4">
                                {" "}
                                <select
                                  className="form-control unsold-control"
                                  id="spcf3"
                                  {...register("unsoldcat")}
                                  value={selectedUnSold || ""}
                                  onChange={(e) =>
                                    setValue("unsoldcat", e.target.value)
                                  }
                                >
                                  <option value="">--Select category--</option>

                                  {getpageData?.responsedata?.list?.map(
                                    (ele) => {
                                      if (ele.cid != decode(ctid)) {
                                        return (
                                          <option key={ele.cid} value={ele.cid}>
                                            {ele.cname}
                                          </option>
                                        );
                                      }
                                    }
                                  )}
                                </select>
                                {/* <br /> */}
                                Unsold players will transfer to this category.
                              </div>
                              {/* </div>
                              </div> */}
                            </div>

                            <div className="col-md-12">
                              <button
                                className="button catadd-btns"
                                type="submit"
                                style={{
                                  borderRadius: "8px",
                                  marginLeft: "16px",
                                }}
                              >
                                Submit
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Editcategory;
